module.exports = __webpack_public_path__ + "media/images/flags/16/Philippines-c6adbd021f7d84a24bd37774684eee2f.png";